import React from 'react';

class About extends React.Component {
	render() {
		return(

			<div>
				<div className="navbar-top">
		          <div className="site-brand">
		            <div className="side-nav-panel-left">
			            <a href="/"> 
			              <i className="fa fa-arrow-left" style={{fontSize: '21px',color: '#F0592D', paddingRight: '8px'}}></i>
			            </a>
		            </div>
		          </div>
		          <div className="site-brand">
		            <a href="/"> 
		              <h2><span className="st2">XPRESS</span><span className="st1">Lite</span></h2>
		            </a>
		          </div>
		          
		        </div>

		        <div className="pages section">
					<div className="container">
						<div className="blog-single">
							<div className="blog-single-content">
								<h4>About Us</h4>
								<div className="byline">
									
								</div>
								<div >
									<p style={{textAlign: 'justify'}}><b><i>XpresssLite</i></b> is a user-friendly & light-weight app for IndianOilPeople to catch the Company’s news and happenings anywhere, anytime, on the go! You can now track important news and achievements unfolding at your workplace and around, browse through the latest news releases and a host of latest information now accessible at your fingertips.</p>
								</div>
								
							</div>		
						</div>
					</div>	
				</div>
				<div id="fakeLoader"></div>

				<div className="footer" style={{position:'absolute', width:'100%', bottom:'0',}}>
					<div className="container">
						<div className="copyright">
							<span>Copyright © IndianOilXpress</span><br/>
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
                <a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
                <a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
				<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
				<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>
				<a href="https://play.google.com/store/apps/developer?id=Indian%20Oil%20Corporation%20Ltd.&hl=en" target="_blank"><i class="fab fa-google-play"></i></a>
						</div>
					</div>
				</div>

			</div>

		)
	}
}

export default About;


// WEBPACK FOOTER //
// ./src/About.js